let config = {
	googleRecaptchaKey: '6LfRMrkpAAAAABFleSf3n-epMUcfoFiE5pFz35Rg',
	facebookClientId: '1514108095529593',
	googleClientId: '984166688818-qsslfaq6nb9ng1m2da38f97eujtcsnc2.apps.googleusercontent.com',
	appleClientId: 'www.vizio.com',
	appleRedirectURI: 'https://www-dev.vizio.com/en/home',
	consentMessageFormat: 'text',
	acceptLanguage: 'en-us',
	userIdType: 'vizio_home_user_id',
	consentIds: ['PRIVACY_POLICY', 'ACCOUNT_TERMS_OF_SERVICE', 'OVER_18', 'ADVERTISING_TARGETING'],
	redirectConsentIds: ['PRIVACY_POLICY', 'ACCOUNT_TERMS_OF_SERVICE', 'OVER_18'],
	emailPreferenceConsentIds: ['ADVERTISING_TARGETING', 'SMS_MESSAGING'],
	consentGroupIds: ['VIZIO_ACCOUNT_GROUP'],
	googleAnalyticsId: 'G-D2CE95ERHQ',
	environment: 'development',
	subscriptionKey: '8f699287140845deb00bc8aa4d2f75da',
	dmsJwt:
		'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjaGFubmVsIjoicG9zdG1hbiIsInNjb3BlIjoiZG1zL3JlZHdvbGYifQ.3VeWyLSqa-S6-kG1xhJFAq59rxNSESa6TMqLlmsIyrk'
};

if (window.location.href.includes('www-stage.vizio.com')) {
	config = {
		...config,
		googleRecaptchaKey: '6LfbMrkpAAAAAFwQexStqaYYGdDiRnbRl4l_3Cy2',
		facebookClientId: '1514108095529593',
		googleClientId: '984166688818-qsslfaq6nb9ng1m2da38f97eujtcsnc2.apps.googleusercontent.com',
		appleClientId: 'www.vizio.com',
		appleRedirectURI: 'https://www-stage.vizio.com/en/home',
		googleAnalyticsId: 'G-D2CE95ERHQ',
		environment: 'staging',
		subscriptionKey: '4a702b0fbfe343dfa487dfbbdf06ca22',
		dmsJwt:
			'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjaGFubmVsIjoicG9zdG1hbiIsInNjb3BlIjoiZG1zL3JlZHdvbGYifQ.dil_LIv9Qde_zOKA6M93y3XMPfzaPjlzsdthL2wR7Vs'
	};
} else if (window.location.href.includes('www-preprod.vizio.com')) {
	config = {
		...config,
		googleRecaptchaKey: '6LfjMrkpAAAAAFBoghMOunRkeAJrJkQNpr2-qAuG',
		facebookClientId: '1514108095529593',
		googleClientId: '984166688818-qsslfaq6nb9ng1m2da38f97eujtcsnc2.apps.googleusercontent.com',
		appleClientId: 'www.vizio.com',
		appleRedirectURI: 'https://www-preprod.vizio.com/en/home',
		googleAnalyticsId: 'G-2B9JTTNET6',
		environment: 'preprod',
		subscriptionKey: '9e6ee0a240814c87aa8297ddef4fd646',
		dmsJwt:
			'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjaGFubmVsIjoicG9zdG1hbiIsInNjb3BlIjoiZG1zL3JlZHdvbGYifQ.WuXd97iXRmS9RJTli3jfR3_wi0LnFCjrMQIzu0hp7r4'
	};
} else if (window.location.href.includes('www.vizio.com')) {
	config = {
		...config,
		googleRecaptchaKey: '6LfqMrkpAAAAAARIBQ-TppXnvYlA8H6yP_EimTtF',
		facebookClientId: '1514108095529593',
		googleClientId: '984166688818-qsslfaq6nb9ng1m2da38f97eujtcsnc2.apps.googleusercontent.com',
		appleClientId: 'www.vizio.com',
		appleRedirectURI: 'https://www.vizio.com/en/home',
		googleAnalyticsId: 'G-CDWRDTHW4N',
		environment: 'production',
		subscriptionKey: 'c66fd84f439c498c8aa2230723e4d4be',
		dmsJwt:
			'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjaGFubmVsIjoicG9zdG1hbiIsInNjb3BlIjoiZG1zL3JlZHdvbGYifQ.WuXd97iXRmS9RJTli3jfR3_wi0LnFCjrMQIzu0hp7r4'
	};
}

export const appConfig = config;
